// Image constants for Fielder application
// IMPORTANT: If you update this file, also update Node/shared/constants.js
const IMAGES = {
  // Local assets (keep these version-controlled)
  FIELDER_LOGO: '/fielder-logo_27Oct2024.png',
  FIELD_PLACEHOLDER: '/fieldPlaceholder.png',
  
  // S3 bucket configuration
  BUCKET_NAME: process.env.AWS_S3_BUCKET || 'fielderusa-images',
  REGION: process.env.AWS_REGION || 'us-east-1',
  
  // File validation
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
  
  // Helper functions
  getPlaceholder: (type) => IMAGES.FIELD_PLACEHOLDER, // Could be extended for different placeholders
  isLocalImage: (url) => url && url.startsWith('/'),
  extractFilename: (url) => {
    if (!url || IMAGES.isLocalImage(url)) return null;
    const parts = url.split('/');
    return parts.length > 1 ? parts[parts.length - 1] : null;
  }
};

// User-facing labels for listing statuses (DB enum values stay unchanged)
const LISTING_STATUS_LABELS = {
  'active': 'Bookable on Fielder',
  'contact-only': 'Contact-Only',
  'maintenance': 'Maintenance',
  'inactive': 'Inactive',
  'pending': 'Pending',
};

// Most time slots one checkout can book.
const MAX_BULK_LEGS = 10;

export { IMAGES, LISTING_STATUS_LABELS, MAX_BULK_LEGS };
